import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { fetchUserAttributes } from '../utils/cognito';

const PrivateRoute = ({ element }) => {
    const auth = useAuth();
    const location = useLocation();
    const [userAttrs, setUserAttrs] = useState(null);

      useEffect(() => {
        async function loadUserAttributes() {
        if (!auth.isAuthenticated || !auth.user?.access_token) return;
        try {
            const attrs = await fetchUserAttributes(auth.user.access_token);
            console.log("Fetched attributes from Cognito:", attrs);
            setUserAttrs(attrs);
        } catch (err) {
            console.error("Error fetching user attributes:", err);
        }
        }
        loadUserAttributes();
    }, [auth.isAuthenticated, auth.user]);

    
    // If still loading auth state, show loading indicator
    if (auth.isLoading) {
        return <div>Verifying authentication...</div>;
    }
    
    // If signing in is in progress, show loading
    if (auth.activeNavigator) {
        return <div>Authentication in progress...</div>;
    }
    
    // If authenticated, render the protected element
    if (auth.isAuthenticated) {
        const deactivationDateStr =
        userAttrs?.['custom:deactivation_date'] ||
        auth.user?.profile?.['custom:deactivation_date'];

        console.log("Full user profile:", auth);
        console.log("Fetched attributes (if any):", userAttrs);
        console.log("Deactivation date string:", deactivationDateStr);

        if (deactivationDateStr && deactivationDateStr.trim() !== '') {
        const now = new Date();
        const deactivationDate = new Date(deactivationDateStr);
        if (!isNaN(deactivationDate.getTime()) && deactivationDate < now) {
                console.warn("Account deactivated. Redirecting to external site...");
                auth.removeUser();
                window.location.href = "https://www.wikipedia.org/";
                return null;
            }
        }

        return element;
    }
    
    // Add debug logging
    console.log("Not authenticated, redirecting to login", {
        isLoading: auth.isLoading,
        activeNavigator: auth.activeNavigator,
        isAuthenticated: auth.isAuthenticated,
        user: auth.user
    });

    const requestedUrl = location.pathname + location.search;
    
    // Otherwise redirect to login
    return (
        <Navigate
        to={`/login?redirectTo=${encodeURIComponent(requestedUrl)}`}
        replace
        />
    );


};

export default PrivateRoute;